function nl2br(str) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    const breakTag = '<br>';
    return (str + '').replace(/(\r\n|\n\r|\r|\n)/g, breakTag + '$1');
}
